// Returns '-1' when the value is undefined, and it forces to return the current PlanningVersion
export const castId = (value: string | undefined): string => {
  const newValue = Number(value)

  return isNaN(newValue) ? '-1' : value ?? '-1'
}
